module.exports = __webpack_public_path__ + "static/media/grognon.fd2a8bb2.gif";